<template>
    <div class="position-relative">
        <!-- Begin Page Content -->
        <div class="bg-white border-radius-5 chartDtata">
            <loader v-if="pageLoader"></loader>
            <div v-show="showForm" class="showModal">
                <div v-if="chart_type == 'glucose'">
                    <glucose-form  from = "" />
                </div>
                <div v-if="chart_type == 'bp'">
                    <blood-pressure-form from = "" />
                </div>
                <div v-if="chart_type == 'weight'">
                    <weight-form from = "" />
                </div>
                <div v-if="chart_type == 'sleep'">
                    <sleep-form from = "" />
                </div>
            </div>
        </div>
        <div class="chartDtata mt-3">
            <div><!--  v-show="!showForm" -->
                <div class="bg-white border-radius-5 p-3 mb-4" style="width:100%;height:500px" id="chartdiv"></div>
                <div>
                    <div class="mt-2 d-flex justify-content-between align-items-center">
                        <h3>Historical data {{chart_type}}</h3>
                        <div v-if="chart_type == 'glucose' || chart_type == 'weight' || chart_type == 'bp' || chart_type == 'sleep'">
                            <button @click="toggleForm()" type="button" class="btn btn-default btn-blue">Add Log</button>
                        </div>
                    </div>
                    <table class="table separateTable">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody v-if="pageLoader">
                            <table-loader :colspan="3"></table-loader>
                        </tbody>
                        <tbody v-else-if="!pageLoader && !chronologicalData.length">
                            <no-record :type="'table'" :colspan="2"></no-record>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(item, index) in chronologicalData" :key="index">
                                <td>{{ formatDate(item.xValue, chart_type == 'glucose' ? true : false) }}</td>
                                <td v-if="chart_type != 'bp' && chart_type != 'sleep'">{{ item.yValue }}</td>
                                 <td v-if="chart_type == 'sleep'">{{ `${sleepTimeInHours(item.yValue)} hrs` }}</td>
                                <td v-if="chart_type == 'bp'">{{ item.highValue }}/{{ item.lowValue }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <!-- End of Page Wrapper -->
</template>
<script>
    import moment from 'moment'
    import * as am5 from '@amcharts/amcharts5'
    import * as am5xy from "@amcharts/amcharts5/xy";
    import BloodPressureForm from '../user/forms/BP-data'
    import GlucoseForm from '../user/forms/glucose-level'
    import WeightForm from '../user/forms/weight-data'
    import SleepForm from '../user/forms/sleep-data'
    // var ;
    export default {
        components: {
            BloodPressureForm,
            GlucoseForm,
            WeightForm,
            SleepForm
        },
        data() {
            return {
                pageLoader : false,
                showForm: false,
                chart : {},
                series : {}
            };
        },
        props:['chart_type'],
        watch:{
            chart_type(){
                // this.chart.clear();
                document.getElementById('chartdiv').innerHTML = "";
                this.chart = {};
                this.series = {};
                this.ChangeChart()
            }
        },
        computed: {
            chronologicalData() {
                return this.chartData[this.chart_type].sort((a,b) => {
                    if(a.xValue > b.xValue) return -1
                    if(a.xValue < b.xValue) return 1
                    return 0
                })
            }
        },
        methods:{
            toggleForm() {
                this.showForm = !this.showForm
            },
            redraw(obj) {
                this.series.data.setAll(this.chartData[this.chart_type]);
                this.series.appear(1000);
            },
            createChart() {
                let timeUnit = this.chart_type == 'glucose' ? "minute" : "day" 
                let count = this.chart_type == 'glucose' ? 15 : 1 
                var root = am5.Root.new("chartdiv");
                this.chart = root.container.children.push(am5xy.XYChart.new(root, {
                    panX: true,
                    panY: false,
                    wheelX: "panX",
                    wheelY: "zoomX"
                }));

                // var cursor = chart.set("cursor", am5xy.XYCursor.new(root, {
                //     behavior: "none"
                // }));
                // cursor.lineY.set("visible", false);

                var xAxis = this.chart.xAxes.push(
                    am5xy.DateAxis.new(root, {
                        maxDeviation: 0.2,
                        baseInterval: {
                            timeUnit: timeUnit,
                            count: count
                        },
                        renderer: am5xy.AxisRendererX.new(root, {}),
                        tooltip: am5.Tooltip.new(root, {})
                    })
                );

                var yAxis = this.chart.yAxes.push(
                    am5xy.ValueAxis.new(root, {
                        renderer: am5xy.AxisRendererY.new(root, {}),
                    })
                );

                xAxis.get("renderer").grid.template.setAll({
                    stroke: am5.color("#f3f3f3"),
                    strokeWidth: 1,
                    strokeOpacity: 0.8,
                })
                yAxis.get("renderer").grid.template.setAll({
                    stroke: am5.color("#f3f3f3"),
                    strokeWidth: 1,
                    strokeOpacity: 0.8,
                })
                if(this.chart_type == 'glucose') {
                    this.series = this.chart.series.push(am5xy.SmoothedXLineSeries.new(root, {
                        name: "Series",
                        minBulletDistance: 10,
                        connect: false,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        valueYField: "yValue",
                        valueXField: "xValue",
                        tooltip: am5.Tooltip.new(root, {
                            pointerOrientation: "horizontal",
                            labelText: "{valueY}"
                        })
                    }));
                } else if(this.chart_type == 'bp'){
                    var color = root.interfaceColors.get("background");
                    this.series = this.chart.series.push(am5xy.ColumnSeries.new(root, {
                        name: "Series",
                        xAxis: xAxis,
                        yAxis: yAxis,
                        valueYField: "lowValue",
                        openValueYField: "highValue",
                        valueXField: "xValue",
                        tooltip: am5.Tooltip.new(root, {
                            labelText: "[bold]{valueX.formatDate()}: {openValueY}/{valueY}"
                        })
                    }));
                    this.series.columns.template.setAll({
                        tooltipText: "[bold]{valueX.formatDate()}: {valueY}",
                        width: am5.percent(90),
                        tooltipY: 0
                    });
                } else {
                    this.series = this.chart.series.push(am5xy.ColumnSeries.new(root, {
                        name: "Series",
                        xAxis: xAxis,
                        yAxis: yAxis,
                        valueYField: "yValue",
                        valueXField: "xValue",
                        tooltip: am5.Tooltip.new(root, {
                            labelText: "[bold]{valueX.formatDate()}: {valueY}"
                        })
                    }));
                    this.series.columns.template.setAll({
                        tooltipText: "[bold]{valueX.formatDate()}: {valueY}",
                        width: am5.percent(90),
                        tooltipY: 0
                    });
                }

                // Add scrollbar
                // this.chart.set("scrollbarX", am5.Scrollbar.new(root, {
                // orientation: "horizontal"
                // }));

                this.series.set("stroke", am5.color("#563089"));
                this.series.set("fill", am5.color("#563089"));

                var data = this.chartData[this.chart_type];

                this.series.data.setAll(data);

                this.series.appear(1000);
                this.chart.appear(1000, 100);
            },
            ChangeChart(){
                if(this.chartData[this.chart_type].length == 0) {
                    let input_json = {
                        'globalParams': {
                            innerPage: true
                        },
                        'localParams': { "parameter": this }
                    }
                    this._runGetChartData(input_json)
                } else {
                    setTimeout(() => {
                        this.createChart()
                    }, 100);
                }
            }
        },
        created(){
            // this.pageName(this.chart_type == 'bp' ? 'Blood Pressure' : this.chart_type)
            this.ChangeChart()
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/website/history-data/charts.vue